<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                <dl class="modal_content">
                    <dt class="ellipsis maintit">
                        <i>Category : {{this.categoryNm}}</i>
                    </dt>
                    <dd>
                        <div class="view_cont">
                            <div>
                                <span class="gridtop_wrap_satisfaction">
                                  <em class="txt_info">
                                    <ul>
                                      <li>A : The Model lists are inaccurate	</li>
                                      <li>B : This Content is insufficient. I need more information.</li>
                                      <li>C : This content has the fault. It must be fixed.</li>
                                      <li>D : I have a question about this content.</li>
                                    </ul>
                                  </em>
                                </span>
                            </div>
                            <!-- tab -->
                            
                            <div class="grid_wrap number-cell">
                            <!-- Count -->
                            <div class="grid_total">

                                Total&nbsp;Count&nbsp;
                                <em>{{ totalCount | numberFormat }}</em>
                            </div>
                                <!-- Grid -->
                               <toast-grid
                                    :gridId="gridId"
                                    ref="GridId"
                                    :data="gridData"
                                    :columns="columns"
                                    :options="options"
                                    :key="gridKey"
                                    :header="header"
                                    :pageOptions="pageOptions"
                                    :isTotalCount="false"
                                />
                            </div>
                            <div class="paginate">
                                <sdl-pagination
                                    :current-page="currentPage"
                                    :total-rows="totalCount"
                                    :per-page="perPage"
                                    @change="search"
                                    align="center"
                                />
                            </div>
                        </div>
                    </dd>
                </dl>

            </div>
        </div>
    </div>
</template>

<script>
import Vue                  from 'vue';
import axios                from 'axios';
import qs                   from 'query-string';
import $                    from 'jquery';
import store                from '@/vuex/store';
import SDLUtil              from '@/utils/SDLUtil';
import ToastGrid            from '~c/ToastGrid';
import { EventBus }         from '@/utils/EventBus';

export default {
    name: 'searchUserPop',
    components: {
        'toast-grid': ToastGrid,
    },
    props : ['knowledgeFromDate', 'knowledgeToDate','viewFromDate', 'viewToDate','corpNo','contentType','categoryCd','categoryNm'],
    data() {
        return {
            pageName: 'unreadPop',
            loginId: '',
            loginNo: '',
            loginNm: '',

            knowledgeDetail: {},

            currentPage: 1,
            totalCount : 0,
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            gridId: 'GridIdPop',
            gridKey: 0,
            header: {
                height: 80,
                complexColumns: [
                    {
                        header: 'Unhelpful',
                        name: 'mergeColumn1',
                        childNames: ['UNHELPFUL_A_CNT', 'UNHELPFUL_B_CNT', 'UNHELPFUL_C_CNT','UNHELPFUL_D_CNT','UNHELPFUL_CNT']
                    },
                ]
            },
            columns : [
                
                {
                    header: "Subject",
                    name: "KNOWLEDGE_TITLE",
                    width: 250,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Registered by",
                    name: "REG_USER_NM",
                    width: 100,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Date",
                    name: "REG_DT",
                    width: 100,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                
                {
                    header: "Helpful",
                    name: "HELPFUL_CNT",
                    align: "right",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "A",
                    name: "UNHELPFUL_A_CNT",
                    align: "right",
                    width: 50,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "B",
                    name: "UNHELPFUL_B_CNT",
                    align: "right",
                    width: 50,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "C",
                    name: "UNHELPFUL_C_CNT",
                    align: "right",
                    width: 50,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D",
                    name: "UNHELPFUL_D_CNT",
                    align: "right",
                    width: 50,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Total",
                    name: "UNHELPFUL_CNT",
                    align: "right",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Score(%)",
                    name: "SCORE",
                    align: "right",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Views",
                    name: "VIEW_CNT",
                    align: "right",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 265,
            },
            pageOptions: {
            },
        };
    },
    created() {
        
    },

    mounted() {
        this.onSearch('1');
    },
    methods: {
        async onSearch(pageNo) {
            let categoryCds = this.categoryCd.split(',');
            let categoryCd1 = categoryCds[0] || '';
            let categoryCd2 = categoryCds[1] || '';
            let categoryCd3 = categoryCds[2] || '';
            if (!pageNo) pageNo = 1;
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerContentsSatisfactionPopup.skp`,
                    qs.stringify({
                    page                : pageNo,
                    RHQSUBCD            : this.corpNo,
                    CONTENTTYPE         : this.contentType,
                    PRD_CATEGORY_CD1    : categoryCd1,
                    PRD_CATEGORY_CD2    : categoryCd2,
                    PRD_CATEGORY_CD3    : categoryCd3,
                    KNOWLEDGE_FROM_DATE : this.knowledgeFromDate,
                    KNOWLEDGE_TO_DATE   : this.knowledgeToDate,
                    VIEW_FROM_DATE      : this.viewFromDate,
                    VIEW_TO_DATE        : this.viewToDate,        
                    }),
                )
                .then(res => {
                    let data = res.data;
                    this.totalCount = data.count;
                    this.gridData = data.rows;
                    this.gridKey++;
                    this.currentPage = pageNo;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/KnowledgeCategoryPop.vue